import React from 'react';
import hoistStatics from 'hoist-non-react-statics';
import { injectIntl as origInjectIntl, intlShape } from 'react-intl';

export default function injectIntl(WrappedComponent, options = {}) {
    const OrigInjectIntl = origInjectIntl(WrappedComponent, options);
    const InjectIntl = (props, context) => (
        <OrigInjectIntl
            {...props}
            messages={context.messages}
        />
    );

    InjectIntl.contextTypes = {
        messages: React.PropTypes.object
    };

    return hoistStatics(InjectIntl, WrappedComponent);
}

export {
    intlShape
};



// WEBPACK FOOTER //
// ./app/common/injectIntl.js